import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { authHeader, getUserToken, clearUserToken } from "@/utils/userAuth";
import { CheckCircle2, BookOpen, Loader2, LogOut } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function CourseFullPage() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!getUserToken()) { navigate("/"); return; }
    axios.get(`${API}/users/me`, { headers: authHeader() }).then(({ data }) => setUser(data)).catch(() => navigate("/"));
  }, [navigate]);

  if (!user) return <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--np-tertiary)" }}><Loader2 className="animate-spin" size={26} style={{ color: "var(--np-secondary)" }} /></div>;

  const hasFull = !!user.has_access_full_course;

  return (
    <main style={{ background: "var(--np-tertiary)" }} className="min-h-screen">
      <header className="border-b" style={{ background: "var(--np-quaternary)", borderColor: "rgba(26,42,58,0.06)" }}>
        <div className="mx-auto px-6 md:px-10 py-2.5 flex items-center justify-between" style={{ maxWidth: 1280 }}>
          <img
            src="https://customer-assets.emergentagent.com/job_ciclo-responsabilita/artifacts/ypgcjh4z_11%20%2829%29.png"
            alt="Neuroscienza Pratica"
            className="block"
            style={{
              width: "clamp(220px, 24vw, 380px)",
              aspectRatio: "4 / 1",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
          <button onClick={() => { clearUserToken(); navigate("/"); }} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-semibold border" style={{ color: "var(--np-primary)", borderColor: "#dbe3ec" }}>
            <LogOut size={13} /> Esci
          </button>
        </div>
      </header>

      <section className="mx-auto px-6 py-20 text-center" style={{ maxWidth: 720 }}>
        {hasFull ? (
          <>
            <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6" style={{ background: "var(--np-tension)" }}>
              <CheckCircle2 size={32} color="#ffffff" />
            </div>
            <p className="text-[12px] tracking-[0.22em] uppercase font-semibold mb-3" style={{ color: "var(--np-secondary)" }}>Benvenuto nel corso completo</p>
            <h1 className="text-3xl md:text-5xl leading-tight" style={{ color: "var(--np-primary)", fontFamily: "Merriweather, serif" }}>Hai sbloccato Neuroscienza Pratica — Figlio a Carico</h1>
            <p className="mt-5 text-lg leading-relaxed" style={{ color: "#2a3a4a" }}>
              Riceverai a breve un'email con le indicazioni per accedere alle restanti lezioni del corso. Nel frattempo puoi riguardare quelle già viste e prenotare la tua consulenza gratuita.
            </p>
            <div className="mt-8 flex flex-wrap gap-3 justify-center">
              {(() => {
                const url = (typeof window !== "undefined" && window.__EDU_STREAM_URL__) || process.env.REACT_APP_EDU_STREAM_URL || "";
                return url ? (
                  <a className="cta-btn" href={url} target="_blank" rel="noreferrer" data-testid="cta-edu-stream">
                    Vai alla piattaforma corso <BookOpen size={16} />
                  </a>
                ) : null;
              })()}
              <a className="cta-btn cta-btn--ghost-light" href="/corso/lezione/1"><BookOpen size={16} /> Rivedi le lezioni</a>
            </div>
          </>
        ) : (
          <>
            <h1 className="text-3xl md:text-4xl leading-tight" style={{ color: "var(--np-primary)", fontFamily: "Merriweather, serif" }}>Corso completo non ancora attivo</h1>
            <p className="mt-4 text-sm" style={{ color: "var(--np-muted)" }}>Completa prima la Lezione 3.</p>
            <a href="/corso/lezione/3" className="cta-btn mt-7 inline-flex">Vai alla Lezione 3</a>
          </>
        )}
      </section>
    </main>
  );
}
